// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f58e3139","885":"9c2cf171","921":"20b911ce"}[chunkId] + ".chunk.js";
};